import React from "react";
import { useState, useEffect, useMemo } from "react";
import { SearchInputComponent } from "../../../../../common/components";
import { ProviderRequestSearchAndFiltersProps } from "./search-and-filter-type";
import { Stack, Badge } from "@mui/material";
import FilterIcon from "../../../../../assets/icons/filter-icon.svg";
import "./provider-search-and-filters.scss";

const ProviderRequestSearchAndFilters: React.FC<
  ProviderRequestSearchAndFiltersProps
> = ({
  onSearch,
  onFilterChange,
  placeholder = "Search by Business name, Business Type, Request ID etc.",
  appliedFiltersCount = 0,
  isFilterOpen = false,
  setIsFilterOpen,
  searchRef,
  isReset = false,
  localSearchText,
}) => {
  return (
    <div className="provider-requests-search-and-filters-wrapper search-and-filters-wrapper">
      <div className="search-input-wrapper">
        <SearchInputComponent
          placeholder={placeholder}
          onSearch={onSearch}
          ref={searchRef}
          localSearchText={localSearchText}
        />
      </div>
      <div
        className="provider-requests-icon-filter filter-icon-wrapper"
        onClick={() => setIsFilterOpen && setIsFilterOpen(!isFilterOpen)}
        tabIndex={0}
      >
        <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
          <Badge color="secondary" badgeContent={appliedFiltersCount}>
            <div className="icon-image-and-text">
              <img src={FilterIcon} alt="Filter Icon" />
              Filter
            </div>
          </Badge>
        </Stack>
      </div>
    </div>
  );
};
export default ProviderRequestSearchAndFilters;
